"use client";

// ===========================================
// konakla - "Çerez Tercihleri" butonu
// ===========================================
//
// Çerez banner'ı bir kez kapatıldıktan sonra KENDİLİĞİNDEN bir daha açılmıyor.
// Oysa /cookies (:62, :255, :270) ve /kvkk (:585) sayfalarında "izninizi
// dilediğiniz zaman geri alabilirsiniz" taahhüdü yazılı. Bu buton, o taahhüdün
// karşılığı olan tek erişim noktasıdır.
//
// Footer bir SUNUCU bileşeni olduğu için buton ayrı bir istemci bileşenidir.

import { openCookiePreferences } from "./cookie-banner";

export function CookiePreferencesButton({ className }: { className?: string }) {
  return (
    <button type="button" onClick={openCookiePreferences} className={className}>
      Çerez Tercihleri
    </button>
  );
}
